import * as React from 'react';

function SvgIntersect(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M0 2a2 2 0 012-2h8a2 2 0 012 2v2h2a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2v-2H2a2 2 0 01-2-2V2zm5 10v2a1 1 0 001 1h8a1 1 0 001-1V6a1 1 0 00-1-1h-2v5a2 2 0 01-2 2H5zm6-8V2a1 1 0 00-1-1H2a1 1 0 00-1 1v8a1 1 0 001 1h2V6a2 2 0 012-2h5z' />
		</svg>
	);
}

export default SvgIntersect;
